import JsonLd from './JsonLd';
import { SITE_URL } from './Seo';
import { LIVE_TOOLS } from '../data/tools';

export default function HomeJsonLd() {
  const data = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${SITE_URL}/#webpage`,
        url: `${SITE_URL}/`,
        name: 'PixelUtility — Free Online Tools',
        isPartOf: { '@id': `${SITE_URL}/#website` },
        about: { '@id': `${SITE_URL}/#organization` },
      },
      {
        '@type': 'ItemList',
        name: 'Free Online Tools',
        itemListElement: LIVE_TOOLS.map((tool, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: tool.name,
          url: `${SITE_URL}${tool.landingPath}`,
          description: tool.description,
        })),
      },
    ],
  };

  return <JsonLd data={data} />;
}
